<template>
  <div class="custom-find">
    <el-dialog
      :modal-append-to-body="false"
      :visible.sync="visible"
      width="450px"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <find-pwd-comp
        :visible-status="visible"
        @goto="goTo"
      >
      </find-pwd-comp>
      <div
        slot="footer"
        class="findPwd-footer"
      >
        遇到其他问题，进行账号申诉请拨打400-8126909或直接<a @click="showServic">联系客服</a>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/* eslint-disable */
import { mapMutations } from 'vuex'
import findPwdComp from '@/components/user/findPwdComp'
export default {
  name: 'FindPwdDialog',
  components: {
    findPwdComp
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let visible = this.value
    return {
      visible,
      analysis: {
        meiqia: { category: 'custom_service', action: 'click_meiqia', label: '美洽客服' }
      }
    }
  },
  computed: {
    // submitBtnDisabled: function() {
    //   //默认隐藏注册按钮，填写正确后显示
    //   return !(this.codeFlag && this.otherFlag);
    // }
  },
  watch: {
    value(val) {
      console.log('找回密码的监听状态', val, '--------')
      this.visible = val
    }
  },
  methods: {
    //跳转到页面
    goTo(str, str2) {
      this.visible = false
      this.$emit('goto', str, str2)
    },
    showServic() {
      this.$.showService()
    }
  }
}
</script>

<style lang="scss">
.custom-find {
  .el-dialog {
    border-radius: 5px;
  }
  .el-dialog__header,
  .el-dialog__body,
  .el-dialog__footer {
    padding: 0;
  }
  .findPwd-footer {
    height: 56px;
    line-height: 56px;
    background: #eff1f8;
    margin-top: 66px;
    font-size: 14px;
    text-align: center;
    border-radius: 0 0 5px 5px;
    a {
      color: dodgerblue;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>
